export default __webpack_public_path__ + "static/media/gallery_02.1af00e5b.jpg";